import { useCallback, useEffect, useRef } from "react";

export const useCarouselAutoplay = (carouselApi, slideCount, delay = 7000) => {
  const timeoutRef = useRef(null);
  const hoveringRef = useRef(false);

  const clearTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const scheduleNext = useCallback(() => {
    clearTimer();
    if (!carouselApi || slideCount <= 1 || hoveringRef.current) return;
    timeoutRef.current = setTimeout(() => {
      carouselApi.scrollNext();
      scheduleNext();
    }, delay);
  }, [carouselApi, slideCount, delay, clearTimer]);

  useEffect(() => {
    scheduleNext();
    return clearTimer;
  }, [scheduleNext, clearTimer]);

  const handleMouseEnter = useCallback(() => {
    hoveringRef.current = true;
    clearTimer();
  }, [clearTimer]);

  const handleMouseLeave = useCallback(() => {
    hoveringRef.current = false;
    scheduleNext();
  }, [scheduleNext]);

  const handleManualNavigation = useCallback(
    (callback) => {
      clearTimer();
      callback?.();
      if (!hoveringRef.current) {
        scheduleNext();
      }
    },
    [clearTimer, scheduleNext]
  );

  return {
    handleMouseEnter,
    handleMouseLeave,
    handleManualNavigation,
  };
};